module.exports = __webpack_public_path__ + "static/media/YoonitSystem.e842d79e.svg";